angular.module('app').controller('ItemCtrl', function (main, $http, $route, $rootScope, $location, $mdToast, appUtils, $scope, $mdDialog, $timeout) {
    "ngInject";

    main.id = main.id || $route.current.params.id;
    main.dialog = $mdDialog;

    if(!main.defaults) {
        main.defaults = {};
    }

    main.handleNewForeignKey = function(obj_key, foreign_key) {
        if(typeof main.item == 'undefined') {
            return;
        }
        if(main.id != 'new' || (main.item.hasOwnProperty(foreign_key))) {
            appUtils.load(obj_key, main.item[foreign_key]).then(
                function(response) {
                    main.item[obj_key] = response.data;
                }
            );
        }
    };

    main.loading = false;
    main._load = function(id) {
        if(!id) {
            id = main.id;
        }

        main.loading = $http({'method': 'GET', 'url': '/api/v1/admin/' + main.name + '/' + id}).then(
            function(response) {
                main.loading = false;
                main.item = response.data;
                $scope.$broadcast('model-loaded');
                return response;
            }
        );

        $scope.$broadcast('model-loading');
        return main.loading;
    };
    if(!main.load) {
        main.load = main._load;
    }

    main._save = function() {
        if($scope.itemForm) {
            $scope.itemForm.$submitted = true;
            if($scope.itemForm.$invalid) {
                appUtils.toast('Please correct errors with the form.', 'error-toast');
                $timeout(() => {
                    document.querySelector('.main form .ng-invalid').scrollIntoView({'behavior': 'smooth'});
                    document.querySelector('.main').scrollBy(0, -100);
                    document.querySelector('.main form .ng-invalid').focus();
                }, 1);
                return false;
            }
        }

        if(main.embedded) {
            $mdDialog.hide(main.item);
            return;
        }

        if(main.loading) {
            var alert = $mdToast.simple().textContent("Save already in progress");
            $mdToast.show(alert);
            return;
        }

        main.loading = $http({'method': main.method, 'url': main.url, 'data': main.item});
        main.loading.then(
            function(response) {
                var message;
                if(typeof main.afterSave == 'function') {
                    afterSaveURL = main.afterSave($rootScope, response, main);
                    return;
                }

                var destinationUrl = main.id == 'new'
                    ? $location.url().replace(/\/new/, '/' + response.data.id)
                    : $location.url();

                if (typeof main.beforeSaveNavigation === 'function') {
                    main.beforeSaveNavigation(response, destinationUrl);
                }

                if(main.id == 'new') {
                    message = "Created";
                    $location.url(destinationUrl);
                } else {
                    message = "Saved";
                    $route.reload();
                }
                var alert = $mdToast.simple().textContent(message);
                $mdToast.show(alert);
            },
            function(response) {
                main.loading = false;
                return response;
            }
        );

        return main.loading;
    };

    main.save = main._save;

    main.url = '/api/v1/admin/' + main.name;
    if(main.id == 'new') {
        main.item = main.defaults;
        angular.extend(main.item, $location.search());
        main.method = 'POST';

        if($location.search().copy) {
            $scope.$on('model-loaded', function() {
                $scope.main.item.id = null;
                if(main.copyCollections) {
                    main.copyCollections.forEach(function(coll) {
                        main.item[coll.name].forEach(function(collItem) {
                            delete collItem[coll.key];
                        });
                    });
                }
                $scope.$broadcast('model-copied');
            });
            main.load($location.search().copy);
        }

    } else {
        main.method = 'PUT';
        main.url += '/' + main.id;
        main.load();
        $rootScope.$on('loggedIn', function() { main.load(); });
    }
});

function itemCtrlFactory(name, opts) {
    return function($scope, $controller) {
        "ngInject";
        if(!opts) {
            opts = {};
        }

        var main = this;
        angular.extend(main, opts);

        main.name = name;
        angular.extend(main, $controller('ItemCtrl', {'$scope': $scope, 'main': main}));
    };
}
